/**
 * A QR code drawn as an image (part 36c, FX3: the authenticator app's setup): the app's own encoder (`account/qr.ts`), its
 * dark modules one SVG path with a quiet zone of four modules round it, dark on light whatever the theme (a code must be
 * dark on light to scan), and named for a screen reader (the key beside it is the text alternative).
 */
import { qrCode, qrPath } from '../account/qr.ts';
import { el } from '../ui/dom.ts';
import type { Child } from '../ui/dom.ts';

/** The quiet zone each side, in modules (ISO/IEC 18004: four). */
const QUIET = 4;

/** The QR code of `text`, named `label`; nothing when no code holds it. */
export function QrImage(text: string, label: string): Child {
  const code = qrCode(text);
  if (code === null) return null;
  const side = code.size + QUIET * 2;
  return el(
    'svg',
    { class: 'ac-qr', viewBox: `0 0 ${String(side)} ${String(side)}`, role: 'img', 'aria-label': label, 'shape-rendering': 'crispEdges' },
    el('rect', { width: String(side), height: String(side), fill: '#ffffff' }),
    el('path', { d: qrPath(code), transform: `translate(${String(QUIET)} ${String(QUIET)})`, fill: '#000000' }),
  );
}
